import Axios from '@/store/axios'
var Promise = require('bluebird')

  const initialState = () => ({
    tickets: [],
    departments: [],
    priorities: [ 'low', 'medium', 'high', 'critical', 'emergency']
  });

  const state = initialState();
  const getters = {
    getTicketById: (state) => (id) => {
      return state.tickets.find( (ticket) => ticket.id === id)
    },
    getRepliesByTicketId: (state) => (id) => {
      return state.tickets.find( (ticket) => ticket.id === id).replies.slice().reverse();
    }
  }
  const mutations = {
    SET_DEPARTMENTS : (state, departments) => {
      state.departments = departments;
    },
    SET_TICKETS : (state, ticket_array) => {
      state.tickets = ticket_array;
    },
    UPDATE_TICKET : (state, ticket) => {
      var index = state.tickets.findIndex( current_ticket => current_ticket.id === ticket.id);
      Object.assign(state.tickets[index], ticket);
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    }
  }
  const actions = {
    ADD_REPLY : (context, { ticket_id, reply } ) => {
      return Promise.try( () => {
        return Axios.post(`support/tickets/${ticket_id}`, { details: reply })
      }).then( () => {
        return context.dispatch('GET_TICKET', ticket_id);
      })
    },
    CREATE_TICKET : (context, ticket) => {
      return Promise.try( () => {
        return Axios.post(`support/tickets`, ticket)
      })
    },
    GET_TICKETS : (context) => {
      return Promise.try( () => {
        return Axios.get(`support/tickets`)
      }).then( (ticket_array) => {
        if(ticket_array.data.length > 0) {
          let ticket_array_no_deleted_tickets = ticket_array.data.filter( (ticket) => {
            return ticket.status != 'trash'
          })
          context.commit('SET_TICKETS', ticket_array_no_deleted_tickets)
        }
        return
      })
    },
    GET_TICKET : (context, id) => {
      return Promise.try( () => {
        return Axios.get(`support/tickets/${id}`)
      }).then( (ticket) => {
        context.commit('UPDATE_TICKET', ticket.data);
        return
      })
    },
    GET_DEPARTMENTS : ( context ) => {
      return Promise.try( () => {
        return Axios.get(`support/departments`)
      }).then( (departments) => {
        context.commit('SET_DEPARTMENTS', departments.data)
      })
    }
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
